import { render, staticRenderFns } from "./lazadamygoods.vue?vue&type=template&id=0d3f2889&"
import script from "./lazadamygoods.vue?vue&type=script&lang=js&"
export * from "./lazadamygoods.vue?vue&type=script&lang=js&"
import style0 from "./lazadamygoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports